module.exports = __webpack_public_path__ + "static/media/Avatars_Female-12.76f9382f.png";